import { types as ActionTypes } from './IAB.actions';
import { types as ConfigActionTypes } from '../../ConfigDetails.actions';
import { defaultConfiguration } from '../../../constants';
import { genericReducer } from '/b2b/common/helpers/ReduxHelpers';
import schema from '/b2b/common/state/db/iab/vendor/IabVendor.schema';

export const initialState = {
    ...defaultConfiguration.iab,
    tcf: {
        vendors: [],
    },
};

// USNAT is replaced, not merged: a configuration without it, after a rollback or when switching
// configurations, would otherwise keep the previous one's switch and save it back.
const mergeSavedIab = (state, { configuration: { iab = {} } = {} } = {}) => ({
    ...state,
    ...iab,
    usnat: iab.usnat,
});

export default genericReducer(initialState, {
    [ConfigActionTypes.createSuccess]: (state, { response }) => {
        return mergeSavedIab(state, response);
    },
    [ConfigActionTypes.fetchDetailsSuccess]: (state, { response }) => {
        return mergeSavedIab(state, response);
    },
    [ConfigActionTypes.updateSuccess]: (state, { response }) => {
        return mergeSavedIab(state, response);
    },
    [ActionTypes.fieldChange]: (state, { field, value }) => {
        return {
            ...state,
            [field]: value,
        };
    },
    [ActionTypes.updateIabVendorsSuccess]: (state, { response = {} } = {}) => {
        const { results = [] } = response;
        return {
            ...state,
            tcf: {
                ...state.tcf,
                vendors: results,
            },
        };
    },
    [ActionTypes.addIabVendorSuccess]: (state, { response }) => {
        const id = schema.idAttribute(response);
        return {
            ...state,
            tcf: {
                ...state.tcf,
                vendors: [...(state.tcf?.vendors || []), id],
            },
        };
    },
    [ActionTypes.clearIabVendorsSuccess]: state => {
        return {
            ...state,
            tcf: {
                ...state.tcf,
                vendors: [],
            },
        };
    },
    [ActionTypes.removeIabVendorSuccess]: (state, { response }) => {
        const id = schema.idAttribute(response);
        const vendors = [...(state.tcf?.vendors || [])].filter(
            existingId => `${existingId}` !== `${id}`
        );
        return {
            ...state,
            tcf: {
                ...state.tcf,
                vendors,
            },
        };
    },
});
